import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
} from '@material-ui/core';
import ChatUtils from '../../../control/ChatUtils';
import TIMUtils from '../../../network/TIMUtils';

class MovieChatItem extends React.Component {

    getImageInfo(msg) {
        let url = '';
        let width = 0;
        let height = 0;
        if (TIMUtils.isMessageImage(msg.type)) {
            if (msg.payload && msg.payload.imageInfoArray && msg.payload.imageInfoArray.length > 0) {
                for (let i = 0; i < msg.payload.imageInfoArray.length; i++) {
                    url = msg.payload.imageInfoArray[i].url;
                    if (msg.payload.imageInfoArray[i].width != 0) {
                        width = msg.payload.imageInfoArray[i].width;
                    }
                    if (msg.payload.imageInfoArray[i].height != 0) {
                        height = msg.payload.imageInfoArray[i].height;
                    }
                }
            }
        }
        return { url: url, width: width, height: height };
    }

    renderSys = () => {
        const { classes, data } = this.props;
        return (
            <Grid container direction='row' justify='center' style={{ width: '100vw', paddingTop: 4, paddingBottom: 4 }}  >
                <Typography className={classes.sysmsg}> {data.payload.text}</Typography>
            </Grid>
        );
    }

    renderImage = (data) => {
        const { classes } = this.props;
        let obj = this.getImageInfo(data);
        return (
            <Grid container direction='row' justify='center' style={{ flex: 1, paddingTop: 4, paddingBottom: 4, paddingLeft: 8, paddingRight: 8 }}  >
                <img src={obj.url} height={obj.height} width={obj.width} className={classes.img}></img>
            </Grid>
        );
    }

    render() {
        const { classes, data } = this.props;
        if (data.isSys) {
            return this.renderSys();
        }
        return (
            <Grid container direction='row' style={{ width: '100vw', paddingTop: 4, paddingBottom: 4 }}  >
                <Typography className={classes.nick}> {data.nick + ':'}</Typography>
                {
                    TIMUtils.isMessageText(data.type) && <Grid className={classes.back}>
                        <Grid className={classes.msg}>
                            {
                                ChatUtils.createHtml(data.payload.text)
                            }

                        </Grid>
                    </Grid>
                }
                {
                    TIMUtils.isMessageImage(data.type) && this.renderImage(data)
                }
            </Grid>
        );
    }
}

export default withStyles((theme) => ({
    nick: {
        fontSize: 14,
        color: '#878787',
        marginLeft: 8,
        marginTop: 8,
    },
    sysmsg: {
        fontSize: 11,
        color: '#52C736',
        marginTop: 4,
    },
    img: {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: 4,
    },
    back: {
        backgroundColor: 'tranparent',
        flex: 1,
    },
    msg: {
        padding: theme.spacing(0.5, 0.5, 0.5, 0.5),
        color: '#0D0D0D',
        fontSize: 11,
        backgroundColor: '#FFF',
        borderRadius: 4,
        marginLeft: 8,
        marginRight: 8,
    },

}))(MovieChatItem);